import { render, staticRenderFns } from "./VQNumber.vue?vue&type=template&id=a10b2382&scoped=true"
import script from "./VQNumber.vue?vue&type=script&lang=js"
export * from "./VQNumber.vue?vue&type=script&lang=js"
import style0 from "./VQNumber.vue?vue&type=style&index=0&id=a10b2382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10b2382",
  null
  
)

export default component.exports